import React from 'react';
import classNames from 'classnames';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import styles from './MapZoomOverlay.module.css';

const MapZoomOverlay = (props) => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.control}>
          <button className={classNames(styles.button, styles.in)} onClick={() => props.zoomHandler('in')}>
            <SvgAF img={IconLoader.icon_zoomin} hover={IconLoader.icon_zoomin_hover} />
          </button>
          <button className={classNames(styles.button, styles.out)} onClick={() => props.zoomHandler('out')}>
            <SvgAF img={IconLoader.icon_zoomout} hover={IconLoader.icon_zoomout_hover} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapZoomOverlay;
